import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  loaded(event) {
    if (event.target !== this.element) return

    const heading = this.element.querySelector("[data-concept-explorer-target='heading']")
    if (!heading) return

    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    this.element.scrollIntoView({
      behavior: reducedMotion ? "auto" : "smooth",
      block: "start",
    })
    heading.focus({ preventScroll: true })
  }

  back(event) {
    const arc = document.querySelector("#concepts")
    if (!arc) return

    event.preventDefault()

    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    const heading = arc.querySelector("h2")

    document.querySelectorAll("[data-controller~='concept-link']").forEach((marker) => {
      marker.classList.remove("is-selected")
      marker.removeAttribute("aria-current")
    })

    window.history.replaceState(window.history.state, "", event.currentTarget.href)
    arc.scrollIntoView({
      behavior: reducedMotion ? "auto" : "smooth",
      block: "start",
    })
    heading?.focus({ preventScroll: true })
    this.element.replaceChildren()
  }
}
